import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { fetchMaintenanceRequest } from "../../redux/actions/maintenanceActions";
import MaintenanceBanner from "./MaintenanceBanner";
import MaintenanceScreen from "./MaintenanceScreen";
import SystemStatusScreen from "./SystemStatusScreen";
import Background from "../../assets/login-background.png";

const loadingStyles = {
  wrapper: {
    minHeight: "100vh",
    backgroundColor: "#0f172a",
    backgroundImage: `url("${Background}")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FEF3C7",
    fontSize: "16px",
  },
};

const MaintenanceGuard = ({
  children,
  loading,
  initialized,
  error,
  isMaintenanceActive,
  maintenance,
  mode,
  isBannerActive,
  bannerId,
  isLoggedIn,
  location,
  fetchMaintenanceRequest,
}) => {
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false,
  );
  const isLoginRoute = location && location.pathname === "/login";

  useEffect(() => {
    fetchMaintenanceRequest();
  }, [fetchMaintenanceRequest]);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      fetchMaintenanceRequest();
    };

    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [fetchMaintenanceRequest]);

  if (isOffline) {
    return (
      <SystemStatusScreen
        variant="offline"
        onRetry={fetchMaintenanceRequest}
        isRetrying={loading}
      />
    );
  }

  if (!initialized || (loading && !error)) {
    return <div style={loadingStyles.wrapper}>Učitavanje...</div>;
  }

  if (error) {
    return (
      <SystemStatusScreen
        variant="technical"
        onRetry={fetchMaintenanceRequest}
        isRetrying={loading}
      />
    );
  }

  if (isMaintenanceActive && mode === "block-login") {
    return (
      <MaintenanceScreen
        title={maintenance && maintenance.title}
        message={maintenance && maintenance.fullMessage}
      />
    );
  }

  if (isMaintenanceActive && mode === "after-login" && isLoggedIn) {
    return (
      <MaintenanceScreen
        title={maintenance && maintenance.title}
        message={maintenance && maintenance.fullMessage}
      />
    );
  }

  const showBanner =
    isBannerActive &&
    maintenance &&
    bannerId &&
    (mode !== "before-login" || isLoginRoute);

  return (
    <>
      {showBanner ? <MaintenanceBanner /> : null}
      {children}
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.maintenance ? state.maintenance.loading : false,
  initialized: state.maintenance ? state.maintenance.initialized : false,
  error: state.maintenance ? state.maintenance.error : null,
  isMaintenanceActive: state.maintenance
    ? state.maintenance.isMaintenanceActive
    : false,
  maintenance: state.maintenance ? state.maintenance.maintenance : null,
  mode: state.maintenance ? state.maintenance.mode : null,
  isBannerActive: state.maintenance ? state.maintenance.isBannerActive : false,
  bannerId: state.maintenance ? state.maintenance.bannerId : null,
  isLoggedIn: !!state.user?.userData?.data?.token,
});

export default withRouter(
  connect(mapStateToProps, {
    fetchMaintenanceRequest,
  })(MaintenanceGuard),
);
